import React, { useState } from "react";
import {
    createColumnHelper,
    useReactTable,
    getCoreRowModel,
    getExpandedRowModel,
    flexRender,
    ExpandedState,
    OnChangeFn,
} from "@tanstack/react-table";
import { IRemitterProps } from "../../../pages/remitter/Remmiter";
import { ArrowDownChevy, ArrowRightChevy, RemitterBanner } from "../../../assets/Icons";
import RemitterDetails from "../../../pages/remitter/RemitterDetails";
import KycStatus from "../KycStatus";
import Typograpy from "../Typography";
import { remitterID } from "../../../store";


interface Data {
    id: number;
    name: string;
    age: number;
    occupation: string;
}

interface TableWithDetailPanelProps {
    data: IRemitterProps.remitterData[];
    deleteRemitterHandler: (id: any) => void;
    handleTransactionUpdate: () => void;
    handleSelectedRemitter: (id: any) => void;
    handleResendKycLink: (id: string) => void;
    handleResendLink: (number: any) => void;
    catchKycLink?: string | undefined;
    showToast?: (message: string, type: "success" | "failure") => void;
    datFetchFailure?: boolean
    setSelectedRow: React.Dispatch<React.SetStateAction<number | undefined>>
    setRemitterInfo: React.Dispatch<React.SetStateAction<any>>
    selectRemitterHandler: (SelectedId: number) => void
    selectedRemitter: any
    setSelectedRemitter: React.Dispatch<any>
}

const columnHelper = createColumnHelper<IRemitterProps.remitterData>();

const columns = [
    columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`, {
        header: "Remitter Name",
        enableSorting: true,
    }),
    columnHelper.accessor("email", {
        header: "Remitter email",
        enableSorting: true,

    }),
    columnHelper.accessor("phoneNumber", {
        header: "Remitter Mobile",
        enableSorting: true,
    }),
    columnHelper.accessor("kycStatus", {
        header: "KYC Status",
        cell: (info) => {
            const rowData = info.row.original;
            return rowData?.id !== null && (
                <KycStatus kycStatus={rowData?.kycStatus} />
            )
        },
        enableSorting: true,
    }),
];

const TableWithDetailPanel: React.FC<TableWithDetailPanelProps> = ({
    data,
    deleteRemitterHandler,
    handleTransactionUpdate,
    handleResendKycLink,
    handleSelectedRemitter,
    handleResendLink,
    catchKycLink,
    showToast,
    datFetchFailure,
    setSelectedRow,
    setRemitterInfo,
    selectRemitterHandler,
    selectedRemitter,
    setSelectedRemitter
}) => {
    const [expanded, setExpanded] = useState<ExpandedState>({});

    const handleExpandedChange: OnChangeFn<ExpandedState> = (updaterOrValue) => {
        setExpanded((prev) =>
            typeof updaterOrValue === "function"
                ? updaterOrValue(prev)
                : updaterOrValue
        );
    };

    const tableInstance = useReactTable({
        data,
        columns,
        state: {
            expanded,
        },
        onExpandedChange: handleExpandedChange,
        getCoreRowModel: getCoreRowModel(),
        getExpandedRowModel: getExpandedRowModel(),
    });

    const { getHeaderGroups, getRowModel } = tableInstance;


    return (
        <>
            {data?.length === 0 ? (
                <div className="flex flex-col items-center justify-center mt-[102px] mb-36">
                    <RemitterBanner />
                    <Typograpy
                        tagType="div"
                        text={
                            datFetchFailure
                                ? "Failed to fetch remitter details. Please click on the refresh button"
                                : "Its Empty Here, Let’s Get Started"
                        }
                        className="text-2xl font-normal text-grey-1550 mt-[61px] text-center"
                    />
                </div>
            ) : null}
            {data.length !== 0 && <table style={{ width: "100%" }}>
                <thead>
                    {getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}
                                    style={{ padding: "10px", textAlign: "justify" }}
                                >
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody >
                    {getRowModel().rows.map((row) => (
                        <React.Fragment key={row.id}>
                            <tr
                                className="hover:bg-[#F0F5FF] cursor-pointer"
                                style={
                                    row.original.id === selectedRemitter.id
                                        ? { backgroundColor: "#F0F5FF" }
                                        : {}
                                }
                            >

                                {row.getVisibleCells().map((cell) => {
                                    return (
                                        <td key={cell.id} style={{ padding: "10px" }} onClick={() => {
                                            selectRemitterHandler(row?.original?.id)
                                            setSelectedRow((row?.original?.id));
                                            setRemitterInfo(row?.original);  // Store the clicked row data

                                        }}
                                            className="cursor-pointer">
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    )
                                }
                                )}
                                <td>
                                    <button onClick={() => { row.toggleExpanded(); setSelectedRemitter(row.original) }}>
                                        {row.getIsExpanded() ? (
                                            <ArrowDownChevy />
                                        ) : (
                                            <ArrowRightChevy />
                                        )}
                                    </button>
                                </td>
                            </tr>
                            {row.getIsExpanded() && (
                                <tr>
                                    <td colSpan={columns.length + 1}>
                                        <RemitterDetails
                                            remitterData={row.original}
                                            deleteRemitterHandler={deleteRemitterHandler}
                                            handleTransactionUpdate={handleTransactionUpdate}
                                            handleSelectedRemitter={handleSelectedRemitter}
                                            handleResendKycLink={handleResendKycLink}
                                            handleResendLink={handleResendLink}
                                            catchKycLink={catchKycLink}
                                            showToast={showToast}
                                        />
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            }
        </>
    );
};

export default TableWithDetailPanel;
